"use client"

import { ArrowDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDownIcon = component(Icon)({ as: ArrowDown })
